import { Injectable } from "@angular/core";
import { RequestUtil, RestApiService } from "core/rest-api/index.service";
import { map } from "rxjs/operators";
import { environment } from "environments/environment";
import { FilterService } from "service/filter/filter.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { tap } from "rxjs";
import { fileUtil } from "service/export-file/export.service";
import { exportDataUtil } from "service/export-pdf/export-pdf.service";

const bucketUrl = environment.bucketUrl;

@Injectable({
  providedIn: "root",
})
export class PaymentsService {
  pagination: any;

  constructor(
    private rest: RestApiService,
    private filterService: FilterService,
    private http: HttpClient
  ) {}

  getBalances() {
    return this.rest.get("affiliate/billing/affiliates/balances").pipe(
      map((data) => {
        return data.info["billing-affiliate-balance"];
      })
    );
  }

  getBillingDetail() {
    return this.rest.get<any>("affiliate/billing/affiliates").pipe(
      map((data: any) => {
        const affiliateBillingDetail = data.info["affiliate-billing-details"];
        affiliateBillingDetail.image_front_id_card =
          affiliateBillingDetail?.image_front_id_card
            ? bucketUrl +
              "/billing_preferences/" +
              affiliateBillingDetail.image_front_id_card
            : undefined;
        affiliateBillingDetail.image_back_id_card =
          affiliateBillingDetail?.image_back_id_card
            ? bucketUrl +
              "/billing_preferences/" +
              affiliateBillingDetail.image_back_id_card
            : undefined;
        return affiliateBillingDetail;
      })
    );
  }

  updateBilling(body: any) {
    return this.rest.put<any>("affiliate/billing/affiliates", body);
  }

  getPaymentMethods() {
    return this.rest.get("affiliate/billing/affiliates-payments-methods").pipe(
      map((data) => {
        return data.info["affiliates-payments-methods"];
      })
    );
  }

  getCurrencies() {
    return this.filterService.getPlatform("currencies").pipe(
      map((data) => {
        return data["currencies"];
      })
    );
  }

  getSupportedCurrencies(currencies?: string) {
    return this.rest
      .get(
        "affiliate/billing/affiliates-payments-methods/supported-currencies/" +
          currencies
      )
      .pipe(
        map((data) => {
          return data.info["supported-currencies"];
        })
      );
  }

  createPaymentMethod(body: any) {
    return this.rest.post(
      "affiliate/billing/affiliates-payments-methods/create",
      body
    );
  }

  getListBank() {
    return this.http.get("assets/data/banks.json");
  }

  updatePaymentMethod(body: any) {
    return this.rest.put(
      "affiliate/billing/affiliates-payments-methods/view-update",
      body
    );
  }

  deletePaymentMethod(id: any) {
    return this.rest.delete(
      "affiliate/billing/affiliates-payments-methods/delete/" + id
    );
  }

  getColumns() {
    return this.rest.get("affiliate/billing/invoices/get-options").pipe(
      map((data) => {
        const columnList = data.info["columns-list"];
        let columns: any[] = [];
        const selectedColumns: any[] = [];
        columnList.forEach((item: { key: any; group: any; default: any }) => {
          if (!columns.includes(item?.group)) {
            columns.push(item?.group);
          }
          if (item?.default === 1) {
            selectedColumns.push(item?.key);
          }
        });
        const tamp: any = [];
        columns.forEach((key) => {
          tamp.push({ key: key.toLowerCase(), items: [], group: key });
        });
        columns = tamp;
        columns.forEach((d) => {
          d.items = columnList?.filter(function (el: { group: any }) {
            return d.group === el.group;
          });
        });
        return {
          columns: columns,
          selectedColumns: selectedColumns,
        };
      })
    );
  }

  getInvoicesList(params: any) {
    const options = {
      request: {
        params,
        observe: "response",
      },
    };
    return this.rest.get("affiliate/billing/invoices/index", options).pipe(
      tap((response: HttpResponse<any>) => {
        this.pagination = {
          current_page: response.headers.get("X-Pagination-Current-Page"),
          page_count: response.headers.get("X-Pagination-Page-Count"),
          per_page: response.headers.get("X-Pagination-Per-Page"),
          total_count: response.headers.get("X-Pagination-Total-Count"),
        };
      }),
      map((response) => {
        return {
          results: response.body.info["invoices"] || [],
          pagination: this.pagination,
        };
      })
    );
  }

  uploadAttachment(id: number, payload: any) {
    const formData: FormData = RequestUtil.prepareFormData(payload);
    return this.rest.put(
      "affiliate/billing/invoices/upload-attachment/" + id,
      formData,
      { urlParameters: { id } }
    );
  }

  exportData(queryParams: any) {
    const params = RequestUtil.queryParams(queryParams);
    return fileUtil.exportFile(this.rest, "affiliate/billing/invoices/export", {
      params,
    });
  }

  download(ids: number[]) {
    const params = RequestUtil.queryParams({
      ids: ids?.join(","),
    });

    return exportDataUtil(
      this.rest,
      "affiliate/billing/invoices/download-pdf-zip?lang=vn",
      { params }
    );
  }

  requestBilling(body: any) {
    return this.rest.put<any>(
      "affiliate/billing/invoices/send-payment-request",
      body
    );
  }

  requestPaymentUpgradeOffer(body: any) {
    return this.rest.post(
      "exclusive-offer/exclusive-offer/request-exclusive-offer",
      body
    );
  }

  acceptRequestPayment(id: any) {
    return this.rest.get(
      `exclusive-offer/exclusive-offer/status-payment?id=${id}`
    );
  }

  getPreApp(body: any) {
    return this.rest
      .post(
        "affiliate/reports/statistics?page=1&perPage=100&sortField=day&sortDirection=desc&currency=VND",
        body
      )
      .pipe(
        map((data) => {
          return data?.info.rows.totals;
        })
      );
  }

  getInvoiceDetail(id: number) {
    return this.rest
      .get("affiliate/billing/invoices/" + id)
      .pipe(map((data) => data.info.invoice));
  }

  /**
   * Get offers not exempt tax.
   *
   * @param params Params.
   */
  getOffersNotExemptTax(params: any) {
    return this.rest.get("affiliate/offers-exempt-tax", {
      request: {
        params,
        observe: "response",
      },
    });
  }
}
